"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
//long imports are intentional (imports react with '@wix/social-groups-common')
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var group_1 = require("../group");
var feed_1 = require("../feed");
var members_1 = require("../members");
var wix_experiments_1 = require("@wix/wix-experiments");
var ActivityController_1 = require("../activity/ActivityController");
// DO NOT change. Long imports are intentional here
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var NotificationsController_1 = require("../notifications/NotificationsController");
var Controller_1 = require("../Controller");
var social_groups_api_1 = require("@wix/social-groups-api");
var helpers_1 = require("../helpers");
var constants_1 = require("../../config/constants");
var ErrorHandlerController_1 = require("../errorHandler/ErrorHandlerController");
var SeoGroupBuilder_1 = require("../../seo/SeoGroupBuilder");
var MainController = /** @class */ (function (_super) {
    tslib_1.__extends(MainController, _super);
    function MainController(controllerConfig, experiments, group) {
        var _this = _super.call(this, controllerConfig, group && group.groupId) || this;
        _this.group = group;
        _this.setSEOData = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var seoTags;
            return tslib_1.__generator(this, function (_a) {
                seoTags = this.seoGroup
                    .withGroup()
                    .forLocation(this.getLocation())
                    .build();
                return [2 /*return*/, this.controllerConfig.wixCodeApi.seo.renderSEOTags(seoTags)];
            });
        }); };
        _this.handleLocationChange = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setSEOData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.experiments = new wix_experiments_1.default({ experiments: experiments });
        MainController.setLogger(controllerConfig);
        _this.setControllers(controllerConfig, experiments, group);
        _this.getLocation().onChange(_this.handleLocationChange);
        _this.onUserLogin(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.controllerConfig.setProps({
                    instance: controllerConfig.appParams.instance,
                });
                return [2 /*return*/];
            });
        }); });
        return _this;
    }
    MainController.prototype.pageReady = function ($w, wixAPI) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Props for SSR
                    return [4 /*yield*/, this.setInitialProps()];
                    case 1:
                        // Props for SSR
                        _a.sent();
                        // Props after SSR
                        this.controllers.map(function (controller) { return controller.pageReady($w, wixAPI); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MainController.prototype.getMockGroupProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var post;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, helpers_1.getDefaultPost(this.controllerConfig)];
                    case 1:
                        post = _a.sent();
                        return [2 /*return*/, {
                                group: this.group,
                                apps: helpers_1.DEFAULT_APPS,
                                feedItems: [post],
                            }];
                }
            });
        });
    };
    MainController.prototype.updateConfig = function ($w, updatedConfig) {
        this.controllerConfig.setProps({
            appSettings: this.bootstrapSettings(updatedConfig),
        });
        return Promise.all(this.controllers.map(function (controller) {
            return controller.updateConfig && controller.updateConfig($w, updatedConfig);
        })).catch(function (e) {
            console.error('Controllers update config error', e);
        });
    };
    MainController.prototype.setInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var logLevel, initialProps, controllersProps, flattenProps, e_1, defaultGroupProps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logLevel = MainController.getLogLevel(this.controllerConfig);
                        initialProps = {
                            logLevel: logLevel,
                            appDefinitionId: this.controllerConfig.appParams.appDefinitionId,
                            instance: this.getSiteToken(),
                            appSettings: this.bootstrapSettings(this.controllerConfig.config),
                            location: this.getLocationValues(),
                            language: this.getSiteLanguage(),
                            experiments: this.experiments.all(),
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(this.controllers.map(function (ctrl) {
                                return ctrl
                                    .getInitialProps()
                                    .catch(function (e) { return console.log('Get initial props FAIL:', e); });
                            }))];
                    case 2:
                        controllersProps = _a.sent();
                        flattenProps = controllersProps.reduce(function (acc, props) { return (tslib_1.__assign({}, acc, props)); }, {});
                        Object.assign(initialProps, flattenProps);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Get Initial Controllers Props: FAIL', e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.group) return [3 /*break*/, 8];
                        if (!social_groups_api_1.isDefaultGroup(this.group)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getMockGroupProps()];
                    case 5:
                        defaultGroupProps = _a.sent();
                        Object.assign(initialProps, defaultGroupProps);
                        _a.label = 6;
                    case 6:
                        this.seoGroup = new SeoGroupBuilder_1.SeoGroupBuilder(initialProps);
                        return [4 /*yield*/, this.setSEOData()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        this.controllerConfig.setProps(initialProps);
                        return [2 /*return*/];
                }
            });
        });
    };
    MainController.prototype.getLocationValues = function () {
        // IWixAPI location is nor serializable 🤷‍
        var _a = this.getLocation(), url = _a.url, baseUrl = _a.baseUrl, path = _a.path, query = _a.query;
        return { url: url, baseUrl: baseUrl, path: path, query: query };
    };
    MainController.prototype.setControllers = function (controllerConfig, experiments, group) {
        var translationsController = new controllers_1.TranslationsController(controllerConfig, this.getTranslationsUrl());
        var groupId = group && group.groupId;
        var errorHandlerController = new ErrorHandlerController_1.ErrorHandlerController(controllerConfig, groupId);
        if (!group) {
            this.controllers = [translationsController, errorHandlerController];
            return;
        }
        mobx_1.configure({ isolateGlobalState: true });
        if (social_groups_api_1.isDefaultGroup(group)) {
            this.controllers = [translationsController];
        }
        else {
            this.controllers = [
                translationsController,
                errorHandlerController,
                new controllers_1.AppToastsController(controllerConfig),
                new group_1.GroupController(controllerConfig, experiments, group),
                new members_1.MembersController(controllerConfig, group),
                new feed_1.FeedController(controllerConfig, experiments, groupId),
                new ActivityController_1.ActivityController(controllerConfig, groupId),
                new NotificationsController_1.NotificationsController(controllerConfig, groupId),
                new controllers_1.MemberInvitesController(controllerConfig),
                new controllers_1.BiLoggerController(controllerConfig),
            ];
        }
    };
    MainController.setLogger = function (controllerConfig) {
        loggers_1.ConsoleLogger.mode = MainController.getLogLevel(controllerConfig);
    };
    MainController.getLogLevel = function (controllerConfig) {
        var logLevel = loggers_1.LogLevel.NONE;
        try {
            if (controllerConfig.wixCodeApi.location.query.debug === 'true') {
                logLevel = loggers_1.LogLevel.LOG;
            }
            if (controllerConfig.wixCodeApi.location.query.trace === 'true') {
                logLevel = loggers_1.LogLevel.TRACE;
            }
        }
        catch (e) { }
        return logLevel;
    };
    MainController.prototype.getTranslationsUrl = function () {
        var _a = this.getBaseUrls(), staticsGroupBaseUrl = _a.staticsGroupBaseUrl, staticsBaseUrl = _a.staticsBaseUrl;
        // editor and preview mode fallback
        var baseUrl = staticsGroupBaseUrl || staticsBaseUrl;
        var language = this.getSiteLanguage();
        return baseUrl + "assets/locales/" + constants_1.GROUP_PAGE + "_" + language + ".json";
    };
    return MainController;
}(Controller_1.Controller));
exports.MainController = MainController;
//# sourceMappingURL=MainController.js.map